import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import {doppeActionTypeLinkView} from "./doppe-action-type-link-view";
import React from 'react';
import {doppeLinkSpecIsPage, doppeLinkSpecIsUrl} from "../../client-server-common/types/doppe-action-cta-button";
import {bymoPageGetInnerNavigatablePageById} from "../../client-server-common/bymo-page-utils/bymo-page-utils";
import {DoppeDtoInnerPageType} from "../../client-server-common/types/doppe-dto-inner-page";
import {IDoppeViewerActionContext} from "../../doppe-sdk/doppe-viewer-action-context/doppe-viewer-action-context";

/**
 * Helper function to navigate to a page using the router.
 */
function navigateToPageViaRouter(
    pageId: string,
    actionContext: IDoppeViewerActionContext<any>
) {
    actionContext.performContextCallback(async ({clientServices, bymoPageProps}) => {
        const router = clientServices.viewerRouterClientService;
        const page = bymoPageGetInnerNavigatablePageById(pageId, bymoPageProps);
        
        if (page) {
            switch (page.type) {
                case DoppeDtoInnerPageType.Products:
                    router.navigateToProductsList();
                    break;
                case DoppeDtoInnerPageType.BlogPosts:
                    router.navigateToBlogPostsList();
                    break;
                case DoppeDtoInnerPageType.Events:
                    router.navigateToEventsList();
                    break;
                case DoppeDtoInnerPageType.Bookings:
                    router.navigateToServicesList();
                    break;
                case DoppeDtoInnerPageType.Content:
                default:
                    router.navigateToContentPage(page.slug);
                    break;
            }
        }
    });
}

export const doppeActionTypeLinkViewViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeLinkView, {
    loadViewerComponents: async () => {
        return {
            DoppeActionTypeLinkViewWidget: (await import('./doppe-action-type-link-view-widget/doppe-action-type-link-view-widget')).DoppeActionTypeLinkViewWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeLinkViewWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeLinkViewWidget
                {...renderProps}
            />
        );

    },

    getActionButtonProps: _actionContext => {
        // Widget opener - button props not needed here
        return {};
    },

    activateCTA: actionContext => {
        const url = actionContext.action.settings.url;
        
        // Handle Page link spec - navigate using router
        if (doppeLinkSpecIsPage(url)) {
            const pageId = url.pageId;
            if (pageId) {
                navigateToPageViaRouter(pageId, actionContext);
            }
            return;
        }
        
        // Handle URL string - open in new tab
        if (doppeLinkSpecIsUrl(url)) {
            actionContext.navigateToUrl(url, true);
        }
    }
})